import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

interface Props {
    apiData: any;
    fileName: any;
}
export const ExportToExcel = (props: Props) => {
    const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";

    const exportToCSV = (apiData, fileName) => {
        const ws = XLSX.utils.json_to_sheet(apiData);
        let ascii = 65;
        let celula = String.fromCharCode(ascii) + "1";

        while (ws[celula]) {
            ws[celula].v = ws[celula].v.replace(/^C.._/, "");
            ascii += 1;
            celula = String.fromCharCode(ascii) + "1";
        }

        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });

        FileSaver.saveAs(data, fileName + fileExtension);
    };

    return (
        <button onClick={(e) => exportToCSV(props.apiData, props.fileName)} className="button-excel">Export</button>
    );
};